module.exports = __webpack_public_path__ + "static/media/director.838edd1e.mp3";